/**
 * @param jsonValues.angle_end
 * @param jsonValues.angle_start
 * @param jsonValues.max
 * @param jsonValues.percentile
 * @param jsonValues.percentileText
 * @param jsonValues.result
 * @param jsonValues.value
 */

// ATTENTION UI DESIGNERS
// ---------------------
// This is an Echart definition of a chart. You can explore it in the Echarts PLAYGROUND (https://echarts.apache.org/examples/en/editor.html)
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// Echarts list of examples: https://echarts.apache.org/examples/en/index.html#chart-type-pie
// An example Echart: https://echarts.apache.org/examples/en/editor.html?c=pie-doughnut
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// DOCUMENTATION: https://echarts.apache.org/en/option.html
// NOTE: Always verify that this file works in both Connect and the PLAYGROUND
// NOTE: Developer, when possible, update the `option = options({ ... put example values here if possible ... })` to reflect example data.
// This entire file can be cut and pasted into the PLAYGROUND IF you change the commenting on the following 2 lines

// In the PLAYGROUND, comment out this line. In this file, keep it uncommented.
export { options };
// In the PLAYGROUND, uncomment this line and add/change values. In this file, keep it commented.
// option = options({value: 33, max: 100, percentile: 18, percentileText: "testing 123" });


function options(jsonValues) {
  // VARIABLES BEGIN: all variables pulled in from the jsonValues should be listed here
  const value = jsonValues.value;
  const max = jsonValues.max;
  // const percentile = jsonValues.percentile;
  // const percentileText = jsonValues.percentileText;
  const startAngle = jsonValues.angle_start;
  const endAngle = jsonValues.angle_end;
  const result = jsonValues.result;

  const getHexFromToken = (token) => getComputedStyle(document.documentElement).getPropertyValue(token).trim()
  const getTokenFromFlagInt = (flagInt) => {
    return {
      "0": "--green-600",
      "10": "--gray-500",
      "20": "--warning-500",
      "30": "--red-600",
      "40": "--blue-500",
      "50": "--blue-400"
    }[flagInt] || "--gray-500";
  }
  const getHexFromFlagInt = (colorValue) => getHexFromToken(getTokenFromFlagInt(colorValue));

  // VARIABLES END

  // SET THE DATA BEGIN
  const data = [
    {
      value: value,
      // name: `${percentileText}\n{blackbold|${percentile}}`,
      detail: {
        offsetCenter: ["0%", "0%"],
      },
      title: {
        fontSize: "0.7rem",
        offsetCenter: ["0%", "45%"],
        rich: {
          blackbold: {
            fontWeight: "bold",
            color: "black",
            fontSize: "2rem",
          },
        },
      },
    },
  ];
  // SET THE DATA END

  return {
    grid: {
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
    },
    media: [
      {
        option: {
          series: [
            {
              detail: {
                fontSize: "26px",
              },
            },
          ],
        },
        query: {
          maxWidth: 180,
        },
      },
    ],
    series: [
      {
        axisLabel: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            width: 15,
          },
        },
        axisTick: {
          show: false,
        },
        data,
        detail: {
          color: "inherit",
          fontSize: "40px",
          formatter: `{value}{black| / ${max}}`,
          rich: {
            black: {
              align: "middle",
              color: "black",
              fontSize: "26px",
              lineHeight: 10,
              padding: [0, 0, 0, 5],
              textAlign: "right",
              width: 60,
            },
          },
          textAlign: "left",
        },
        endAngle: endAngle,
        max,
        pointer: {
          show: false,
        },
        progress: {
          clip: false,
          overlap: false,
          roundCap: true,
          show: true,
        },
        splitLine: {
          distance: 0,
          length: 10,
          show: false,
        },
        startAngle: startAngle,
        type: "gauge",
        radius: "100%",
      },
    ],
    visualMap: {
      type: "piecewise",
      show: false,
      pieces: [
        {
          color: getHexFromFlagInt(result),
          max: max,
          min: 0,
        },
      ],
    },
  };
}
